enum Environment {
    DEV = 'dev',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export default Environment;
